/* WAVY-JADE-0926 | wavy-pdp.js (rewrite of the WAVY-JADE-0925 file: the size-guide dialog moved to
   snippets/wavy-size-guide.liquid, which carries its own controller as window.wjSizeGuide).
   Order timeline under the ATC (port of NZS-PDP-ETA-0924): Ordered / Shipped / Delivered.
   WAVY-CRO-1001: delivery is door to door 3-5 business days counted from the order day
   (no cut-off, no ship-day maths). Weekends are skipped; public holidays are not modelled. The order day is the
   shopper's own calendar day. The lead line ("Arrives in 3-5 business days") is static in the snippet; this file
   only paints the dates. window.wjEta.compute(wallClockMs) is pure (wall clock held in UTC fields). */
(function () {
  'use strict';
  if (window.wjEta) return;

  var MIN = 3, MAX = 5; /* WAVY-CRO-1001: business days, door to door */
  var D = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* shopper's local calendar day as a UTC timestamp (Date.UTC of the local fields) */
  function localNow(date) {
    var d = date || new Date();
    return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
  }
  function day0(t) { var d = new Date(t); return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()); }
  function biz(t) { var w = new Date(t).getUTCDay(); return w !== 0 && w !== 6; }
  function nextBiz(t, n) { var d = t; while (n > 0) { d += 864e5; if (biz(d)) n--; } return d; }
  function short(t) { var d = new Date(t); return D[d.getUTCDay()] + ' ' + d.getUTCDate(); }
  function full(t) { var d = new Date(t); return short(t) + ' ' + M[d.getUTCMonth()]; }

  /* pure: now = local wall-clock ms (UTC fields). Returns the delivery window labels. */
  function compute(now) {
    var today = day0(now);
    var a = nextBiz(today, MIN), b = nextBiz(today, MAX);
    var sameMonth = new Date(a).getUTCMonth() === new Date(b).getUTCMonth();
    return {
      today: today, from: a, to: b,
      deliveredLabel: sameMonth ? short(a) + ' – ' + short(b) + ' ' + M[new Date(b).getUTCMonth()] : full(a) + ' – ' + full(b)
    };
  }

  function boot() {
    var box = document.querySelector('[data-wj-eta]');
    if (!box) return;
    var out = box.querySelector('[data-wj-eta-delivered]');
    function paint() {
      if (out) out.textContent = compute(localNow()).deliveredLabel;
    }
    paint();
    box.hidden = false;
    setInterval(paint, 30000);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !window.IntersectionObserver) { box.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { box.classList.add('is-in'); io.disconnect(); }
    }, { threshold: .6 });
    io.observe(box);
  }

  window.wjEta = { version: 'WAVY-CRO-1001', compute: compute, localNow: localNow, minDays: MIN, maxDays: MAX };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* WAVY-CRO-1001: gallery arrows. Below the desktop breakpoint the product gallery is a swipe slider with dots only,
   which leaves mouse users with no way to change image. Add Previous/Next buttons over the slider for fine pointers
   (hover:hover). They scroll the existing list, so the theme's dots, counter and active-slide logic keep working.
   Shown only where the list really scrolls sideways; hidden at the first/last image. */
(function () {
  'use strict';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  var CHEV = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };
  function init(root) {
    var g = (root || document).querySelector('media-gallery.wj-gallery');
    if (!g || g.getAttribute('data-wj-garrows') === '1') return;
    var list = g.querySelector('ul.slider, .product__media-list');
    var host = list && (list.closest('slider-component') || list.parentElement);
    if (!list || !host) return;
    g.setAttribute('data-wj-garrows', '1');
    g.classList.add('has-garrows');
    function mk(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wj-garrow wj-garrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = CHEV[dir];
      b.hidden = true;
      host.appendChild(b);
      return b;
    }
    var prev = mk('prev'), next = mk('next');
    function step() {
      var a = list.children[0], b = list.children[1];
      var w = a ? a.getBoundingClientRect().width : list.clientWidth;
      var gap = a && b ? Math.max(0, b.offsetLeft - a.offsetLeft - a.offsetWidth) : 0;
      return Math.max(1, Math.round(w + gap));
    }
    function sync() {
      var scrolls = list.scrollWidth - list.clientWidth > 4;
      var x = list.scrollLeft;
      prev.hidden = !scrolls || x <= 4;
      next.hidden = !scrolls || x >= list.scrollWidth - list.clientWidth - 4;
    }
    function go(dir) { list.scrollBy({ left: dir * step(), behavior: reduced() ? 'auto' : 'smooth' }); setTimeout(sync, 120); setTimeout(sync, 450); setTimeout(sync, 900); }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    list.addEventListener('scroll', sync, { passive: true });
    list.addEventListener('scrollend', sync);
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) new ResizeObserver(sync).observe(list);
    sync();
    setTimeout(sync, 600); /* images settle */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* WAVY-CRO-1001C: Instagram-style gallery dots (v2, "polish": everything moves in sync). wavy-lightbox.js keeps
   aria-current on the active dot as the slider scrolls. Here the buttons are wrapped in one track inside a fixed
   7-slot window; every dot owns a fixed 14px slot, so nothing re-flows. Only transforms animate: the track slides
   (translateX) so the jade dot is always the centre slot, and each dot scales by its distance from it (data-d 0-3,
   'off' beyond). One duration + easing for both (wavy-gallery.css), so the slide and the resize land together.
   One attributes-only observer on the small dots row (aria-current), nothing document-wide. */
(function () {
  'use strict';
  var STEP = 14, HALF = 3;
  function layout(row) {
    var track = row.__wjIgTrack;
    var btns = track.children;
    var n = btns.length, a = 0;
    for (var k = 0; k < n; k++) if (btns[k].getAttribute('aria-current') === 'true') a = k;
    track.style.transform = 'translateX(' + (HALF - a) * STEP + 'px)';
    for (var i = 0; i < n; i++) {
      var dist = Math.abs(i - a);
      var d = dist > HALF ? 'off' : String(dist);
      if (btns[i].getAttribute('data-d') !== d) btns[i].setAttribute('data-d', d);
      btns[i].tabIndex = d === 'off' ? -1 : 0; /* hidden dots leave the tab order and the a11y tree */
      if (d === 'off') btns[i].setAttribute('aria-hidden', 'true'); else btns[i].removeAttribute('aria-hidden');
    }
  }
  function init(root) {
    var rows = (root || document).querySelectorAll('media-gallery.wj-gallery [data-wj-dots]');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      if (row.__wjIg) continue;
      var track = document.createElement('span');
      track.className = 'wj-dots__track';
      while (row.firstElementChild) track.appendChild(row.firstElementChild);
      row.appendChild(track);
      row.__wjIgTrack = track;
      row.__wjIg = new MutationObserver(function (row) { return function () { layout(row); }; }(row));
      row.__wjIg.observe(track, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
      layout(row);
      row.classList.add('is-ig');
      /* first paint lands without animating; transitions switch on after it */
      setTimeout(function (row) { return function () { row.classList.add('is-ig-ready'); }; }(row), 60);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* WAVY-CRO-1001C: one floating magnifier on the phone gallery. The per-slide icons are hidden (wavy-gallery.css) and
   this fixed button opens the lightbox for whichever slide is in view by clicking that slide's own zoom toggle, so
   wavy-lightbox.js keeps owning the open. Phones only (the button is display:none from 750px). */
(function () {
  'use strict';
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M15.5 15.5 20 20M10.5 7.5v6M7.5 10.5h6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  function current(g, list) {
    var dots = g.querySelectorAll('[data-wj-dot]');
    for (var i = 0; i < dots.length; i++) if (dots[i].getAttribute('aria-current') === 'true') return i;
    var items = Array.prototype.filter.call(list.children, function (li) { return li.offsetWidth > 0; });
    var pitch = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 0;
    return pitch > 0 ? Math.round(list.scrollLeft / pitch) : 0;
  }
  function init(root) {
    var g = (root || document).querySelector('media-gallery.wj-gallery');
    if (!g || g.querySelector('.wj-zoom-float')) return;
    var list = g.querySelector('.product__media-list');
    if (!list || !list.querySelector('.product__modal-opener--image .product__media-toggle')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wj-zoom-float';
    b.setAttribute('aria-label', 'Zoom this photo');
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = ICON;
    b.addEventListener('click', function () {
      var items = Array.prototype.filter.call(list.children, function (li) { return li.offsetWidth > 0; });
      var li = items[current(g, list)] || items[0];
      var t = li && (li.querySelector('.product__modal-opener--image .product__media-toggle') || li.querySelector('.product__media-toggle'));
      if (t) t.click();
    });
    g.appendChild(b);
    g.classList.add('has-zoom-float');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* WAVY-CRO-1001B: smooth accordions. The CSS-only version (::details-content height transition) only animated in
   browsers that support it and never animated the close. Here a click on a .wj-acc summary is intercepted and the panel's
   height is animated with the Web Animations API in BOTH directions (open ~300 ms ease-out, close ~260 ms ease-in), the body
   fades and drifts 4px, and the +/- icon turns in sync (the .is-closing class gives the closed look at the start of the
   close, because [open] stays on until the animation ends). Enter/Space on the summary still work (they fire click).
   Panels stay closed by default. prefers-reduced-motion, or no Element.animate: the native toggle is left alone.
   html.wj-acc-js switches the old ::details-content / fade rules off in wavy-pdp.css so the two never stack. */
(function () {
  'use strict';
  if (window.wjAcc) return;
  /* WAVY-CRO-1001C (Blake): cart-drawer-enhance smooth-drawer curves. The height moves on easeInOutCubic
     cubic-bezier(.645,.045,.355,1) (440ms open / 380ms close); the opening body rises on the drawer's entrance
     curve cubic-bezier(.25,.46,.45,.94) once the panel is moving (BODY_DELAY), so the reveal reads as one beat. */
  var OPEN_MS = 440, CLOSE_MS = 380, BODY_IN_MS = 260, BODY_DELAY = 140;
  var EASE_OPEN = 'cubic-bezier(.645, .045, .355, 1)', EASE_CLOSE = 'cubic-bezier(.645, .045, .355, 1)', EASE_RISE = 'cubic-bezier(.25, .46, .45, .94)';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  if (typeof Element.prototype.animate !== 'function') return;

  function clean(d) {
    var run = d._wjRun;
    if (run) { run.anims.forEach(function (a) { try { a.cancel(); } catch (e) {} }); d._wjRun = null; }
    d.style.overflow = ''; d.style.boxSizing = '';
    d.classList.remove('is-closing');
  }
  function closedHeight(d, sum) { return sum.getBoundingClientRect().height + (d.offsetHeight - d.clientHeight); }

  function toggle(d, sum) {
    var body = d.querySelector('.wj-acc__body');
    var cur = d.getBoundingClientRect().height;      /* where the box is right now (mid-animation too) */
    var willOpen = !d.open || d.classList.contains('is-closing');
    clean(d);
    var from = cur, to, ms, ease, bodyFrames, bodyOpts, anims = [], d0 = d;
    d.style.overflow = 'hidden'; d.style.boxSizing = 'border-box';
    if (willOpen) {
      if (!d.open) d.open = true;
      to = d.getBoundingClientRect().height;          /* natural open height */
      ms = OPEN_MS; ease = EASE_OPEN;
      bodyFrames = [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }];
    } else {
      d.classList.add('is-closing');
      to = closedHeight(d, sum);
      ms = CLOSE_MS; ease = EASE_CLOSE;
      bodyFrames = [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-4px)' }];
    }
    var a = d.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: ms, easing: ease, fill: 'forwards' }); /* forwards: no one-frame flash back to the open height before onfinish */
    anims.push(a);
    if (body) anims.push(body.animate(bodyFrames, willOpen
      ? { duration: BODY_IN_MS, delay: BODY_DELAY, easing: EASE_RISE, fill: 'backwards' }
      : { duration: Math.round(ms * .6), easing: ease, fill: 'forwards' }));
    d._wjRun = { anims: anims };
    a.onfinish = function () {
      if (d._wjRun && d._wjRun.anims[0] !== a) return;   /* superseded by a newer toggle */
      if (!willOpen) d.open = false;
      clean(d0);
    };
  }

  document.addEventListener('click', function (e) {
    var sum = e.target && e.target.closest && e.target.closest('summary');
    if (!sum || e.defaultPrevented) return;
    var d = sum.parentNode;
    if (!d || d.nodeName !== 'DETAILS' || !d.closest('.wj-acc')) return;
    if (reduced()) return;
    e.preventDefault();
    toggle(d, sum);
  });
  document.documentElement.classList.add('wj-acc-js');
  window.wjAcc = { version: 'WAVY-CRO-1001B' };
})();
